

import { LANGUAGE_STORAGE_KEY } from "../constants/language";
import type { TLanguage } from "../types";
import { i18nInstance, initPromise } from "./instance";

export async function setLanguage(lng: TLanguage): Promise<void> {
  await initPromise;
  await i18nInstance.changeLanguage(lng);
  if (typeof window !== "undefined") {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
    document.documentElement.lang = lng;
  }
}
